import React from 'react'

type Props = {
  participantInfo: string
}

export const ParticipantsVoiceItemParticipantInfo = ({
  participantInfo,
}: Props): JSX.Element => (
  <div className="flex justify-end mt-[2.2vw] w-[30.9vw] lg:w-auto text-[3.2vw] lg:text-[1vw] text-[#8B8B8B]">
    {participantInfo}
  </div>
)
